function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    iframe,\n    img,\n    input,\n    select,\n    textarea {\n        height: auto;\n        max-width: 100%;\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { css } from '@emotion/react';
export var assets = css(_templateObject());